<template>
  <v-container>
    <!-- <v-row align="center" class="row--35"> -->
    <v-row class="row--35 mb--100">
      <!-- <v-col class="d-md-none" lg="4" md="4" cols="12">
        <div style="margin-top: -150px;">
          <slot name="thum-img"></slot>
        </div>
      </v-col> -->
      <v-col lg="9" md="9" sm="12" cols="12">
        <div class="about-inner inner">
          <v-row class="mt--60 mt_sm--30">
            <div class="d-sm-flex">
              <div class="p-6">
                <h3 class="heading-title colorBlue mt_sm--0 ml--15">
                  CHECK UP
                </h3>
              </div>
              <div class="p-6">
                <p
                  style="font-size: 13px; line-height: 1.5; color: #777978"
                  class="mb_sm--20 mb_md--20 ml--10 ml_sm--15"
                >
                  (Υγεία, Μetropolitan Hospital, Μητέρα, <br />
                  Metropolitan General, Λητώ, Creta Interclinic)
                </p>
              </div>
            </div>
          </v-row>
          <v-row>
            <v-col xs="8" sm="8" md="12" lg="12" cols="8">
              <v-row class="mt--20">
                <v-col
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="withoutBorder"
                  style="border-right: 1px dotted"
                >
                  <h3 class="heading-title" style="color:red; font-size: 20px">
                    Για τη γυναίκα
                  </h3>

                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Γυναικολογικός έλεγχος
                  </h3>
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    <span class="colorBlue"> • 35 €</span>
                  </h3>
                  <ul>
                    <li>
                      Εξετάσεις Αίματος: Γενική Αίματος, TSH, Σίδηρος, Φερριτίνη
                    </li>
                    <li>Γενική Ούρων</li>
                    <li>Τεστ ΠΑΠ</li>
                    <li>Βασική Γυναικολογική εξέταση</li>
                  </ul>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Υπέρηχος μαστού <span class="colorBlue"> • 25 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Μαστογραφία <span class="colorBlue"> • 40 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--0"
                    style="font-size: 20px"
                  >
                    Τομοσύνθεση <span class="colorBlue"> • 50 €</span>
                  </h3>
                  <p
                    style="font-size: 13px; line-height: 1.5; color: #777978"
                    class="mb_sm--20 mb_md--20 mt--5"
                  >
                    (Μetropolitan Hospital, & Metropolitan General)
                  </p>
                </v-col>
                <v-col
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="withoutBorder"
                  style="border-right: 1px dotted"
                >
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="color:red; font-size: 20px"
                  >
                    Για τον άντρα
                  </h3>
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    <span class="colorBlue"> • 35 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Πρόγραμμα ελέγχου προστάτη
                  </h3>
                  <ul>
                    <li>P.S.A.</li>
                    <li>FREE P.S.A.</li>
                    <li>Κλινική εξέταση προστάτη</li>
                  </ul>
                </v-col>
                <v-col lg="4" md="4" sm="12" cols="12">
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="color:red; font-size: 20px"
                  >
                    Για το παιδί
                  </h3>
                  <h3
                    class="heading-title  mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    <span class="colorBlue"> • 55 €</span>
                  </h3>
                  <h3
                    class="heading-title heading-title-new mt--10  mb--10"
                    style="font-size: 20px"
                  >
                    Προληπτικός έλεγχος υγείας
                  </h3>
                  <ul>
                    <li>Γενική αίματος</li>
                    <li>Σάκχαρο</li>
                    <li>Κρεατινίνη</li>
                    <li>Ουρία</li>
                    <li>Τριγλυκερίδια</li>
                    <li>FT4</li>
                    <li>HDL χοληστερίνης</li>
                    <li>LDL χοληστερίνης</li>
                    <li>Χοληστερίνη αίματος</li>
                    <li>Φερριτίνη</li>
                    <li>Σίδηρος</li>
                    <li>Τ.Κ.Ε.</li>
                    <li>Παιδιατρική εξέταση</li>
                  </ul>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt--50 mt_sm--10">
            <v-col lg="9" md="9" sm="12" cols="12">
              <h3
                class="heading-title heading-title-new mt--10  mb--10"
                style="font-size: 20px"
              >
                Βασικός αιματολογικός έλεγχος σε όλα τα θεραπευτήρια και τα
                διαγνωστικά κέντρα Healthspot:
                <span class="colorBlue"> • 10 €</span>
              </h3>
              <p style="font-size: 16px">
                Περιλαμβάνει: Γενική Αίματος, Σάκχαρο, Ουρία, Κρεατινίνη,
                Χοληστερόλη, HDL, LDL, Τριγλυκερίδια, SGOT, SGPT, TSH, Γενική
                Ούρων.
              </p>
            </v-col>
          </v-row>
          <v-row class="d-block d-sm-none mt--50 mt_sm--10">
            <v-col lg="9" md="9" sm="12" cols="12">
              <h3
                class="heading-title heading-title-new mt--10  mb--10"
                style="font-size: 20px"
              >
                Φτιάξε το δικό σου check up
              </h3>
              <p style="font-size: 16px">
                Αν είσαι κάτοχος της κάρτας Health_e bonus οποιασδήποτε
                βαθμίδας, μπορείς να επισκεφτείς δωρεάν έναν ειδικό παθολόγο του
                δικτύου υγείας του HHG (Υγεία, Metropolitan Hospital, Μητέρα,
                Metropolitan General, Λητώ, Creta Interclinic καθώς και τα
                διαγνωστικά κέντρα HealthSpot). Εκείνος θα σχεδιάσει ειδικά για
                εσένα εξατομικευμένο check up προσαρμοσμένο στις ανάγκες και στο
                ιστορικό υγείας σου, σε ιδιαίτερα προνομιακή τιμή.
              </p>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col class="mt--100 d-none d-md-block" lg="3" md="3" cols="12">
        <div>
          <slot name="thum-img"></slot>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style scoped>
.colorBlue {
  color: rgb(22 71 141);
  font-family: PFBagueSansPro-Bold;
  font-weight: bold;
}

th {
  font-size: 14px !important;
}
.freeTicket {
  background-color: rgb(132, 135, 136);
  position: absolute;
  margin-bottom: 20px;
  left: -23%;
  right: 71%;
  text-align: right;
  color: white;
  font-size: 25px;
  font-weight: bold;
  border-top-right-radius: 25px 22px;
  border-bottom-right-radius: 25px 22px;
  padding-right: 20px;
}

.freeTicketRight {
  background-color: rgb(132, 135, 136);
  position: absolute;
  margin-bottom: 20px;
  left: 0%;
  right: 58%;
  text-align: right;
  color: white;
  font-size: 25px;
  font-weight: bold;
  border-top-right-radius: 25px 22px;
  border-bottom-right-radius: 25px 22px;
  padding-right: 20px;
}

h3 {
  font-family: "PFBagueSansPro-Bold";
}

.v-application p,
body p {
  line-height: 1.5;
}
.v-application ul,
.v-application ol,
body ul,
body ol {
  line-height: 1.5;
}
h3 {
  font-family: "PFBagueSansPro-Bold";
  line-height: 1.5;
}
.v-application p {
  line-height: 1.5;
}
p {
  line-height: 1.5;
}

.v-application p,
body p {
  line-height: 1.5;
}
@media only screen and (max-width: 600px) {
  .heading-title-new {
    font-size: 16px !important;
  }
  .withoutBorder {
    border-right: 0px dotted !important;
  }
}
</style>
